import { IPropertyFile } from '@/models/documents.model';
import { IFile } from '@/models/file.model';
import { getEntityId } from '@/utils';

export const normalizeDocument = (document: Partial<IPropertyFile> | Partial<IFile>): Partial<IPropertyFile> => {
  if ('file_name' in document) {
    const propertyFile = document;

    return {
      id: getEntityId(propertyFile?.PK ?? '') as string,
      file_name: propertyFile.file_name ?? '',
      file_link: propertyFile.file_link ?? '',
      uploadedBy: propertyFile.uploadedBy,
      created: propertyFile.created,
    };
  }

  const file = document as Partial<IFile>;
  return {
    id: file.id ?? '',
    file_name: file.name ?? '',
    file_link: file.link ?? '',
  };
};
